"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const components_common_autocomplete_1 = require("@hotelplan/components.common.autocomplete");
const libs_tracking_1 = require("@hotelplan/libs.tracking");
const TravelDestination_mappers_1 = require("./TravelDestination.mappers");
const TravelDestinationLabel_1 = __importDefault(require("./TravelDestinationLabel"));
const TravelDestinationSuggestion_1 = __importDefault(require("./TravelDestinationSuggestion"));
const TravelDestionation_utils_1 = require("./TravelDestionation.utils");
function defaultRenderSuggestion(item, query) {
    return react_1.default.createElement(TravelDestinationSuggestion_1.default, { item: item, query: query });
}
function renderDestinationTagLabel(item) {
    return react_1.default.createElement(TravelDestinationLabel_1.default, { item: item, label: item.name });
}
function getDestinationName(item) {
    return item.canonicalName || item.name;
}
const TravelDestinationInput = props => {
    const { label, children, placeholder, value, onChange, onSelect, className, config, limit, caption, customLabel, renderSuggestion, } = props;
    const [t] = (0, next_i18next_1.useTranslation)('search');
    const autocompletePlaceholder = !(config === null || config === void 0 ? void 0 : config.disableAutocompleteTags)
        ? placeholder
        : (0, TravelDestionation_utils_1.getShortInformation)(t, value || [], limit) || placeholder;
    return (react_1.default.createElement(components_common_autocomplete_1.AutocompleteComboboxInput, { travelDestinationConfig: config, maxItems: config === null || config === void 0 ? void 0 : config.maxItems, className: className, name: "travelDestination", value: value || [], onChange: onChange, icon: { name: 'planet' }, label: label, customLabel: customLabel, placeholder: autocompletePlaceholder, displayValue: (0, TravelDestionation_utils_1.getShortInformation)(t, value || [], limit), getTagName: getDestinationName, renderTagLabel: renderDestinationTagLabel, renderSuggestion: renderSuggestion !== null && renderSuggestion !== void 0 ? renderSuggestion : defaultRenderSuggestion, caption: caption, onOpen: () => {
            (0, libs_tracking_1.trackTravelDestinations)({
                type: libs_tracking_1.TravelDestinationsEventType.TRAVEL_DESTINATIONS_OPEN,
            });
        }, onCancel: () => {
            (0, libs_tracking_1.trackTravelDestinations)({
                type: libs_tracking_1.TravelDestinationsEventType.TRAVEL_DESTINATIONS_CANCEL,
            });
        }, onApply: items => {
            (0, libs_tracking_1.trackTravelDestinations)({
                type: libs_tracking_1.TravelDestinationsEventType.TRAVEL_DESTINATIONS_APPLY,
                payload: {
                    suggestions: items.map(TravelDestination_mappers_1.mapCanonicalDestinationToTrackableDestination),
                },
            });
        }, onOptionSelect: onSelect
            ? onSelect
            : (item, text) => (0, libs_tracking_1.trackSelectSuggestion)((0, TravelDestination_mappers_1.mapCanonicalDestinationToTrackableDestination)(item), text), onOptionRemove: (item, text) => (0, libs_tracking_1.trackRemoveSuggestion)((0, TravelDestination_mappers_1.mapCanonicalDestinationToTrackableDestination)(item), text) }, children));
};
exports.default = TravelDestinationInput;
//# sourceMappingURL=TravelDestinationInput.js.map